import React, { useState } from 'react';

const Projects = () => {
  const [visibleProjects, setVisibleProjects] = useState(6);
  const [showEndMessage, setShowEndMessage] = useState(false);

  // Function to get language logo
  const getLanguageLogo = (language) => {
    const logos = {
      "React": "./image/react.jpeg",
      "Node.js": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      "MongoDB": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      "React Native": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      "Firebase": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
      "Redux": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
      "Vue.js": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
      "D3.js": "https://d3js.org/logo.svg",
      "Express": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      "PostgreSQL": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
      "Next.js": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
      "Tailwind CSS": "./image/tailwind.jpeg",
      "Framer Motion": "https://www.framer.com/static/images/framer-logo.svg",
      "Stripe": "https://stripe.com/img/v3/home/twitter.png",
      "AWS": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original.svg",
      "Gatsby": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gatsby/gatsby-original.svg",
      "GraphQL": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg",
      "Netlify": "https://www.netlify.com/img/press/logos/logomark.png",
      "Laravel": "./image/laravel.jpeg",
      "PHP": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg",
      "MySQL": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      "Three.js": "https://threejs.org/files/threejs_icon.svg",
      "WebGL": "https://www.khronos.org/assets/images/khronos-group-logo.svg",
      "GSAP": "https://greensock.com/uploads/2019/11/gsap-logo.svg",
      "Angular": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
      "TypeScript": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
      "Django": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg",
      "Python": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      "Flutter": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
      "Dart": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg",
      "Shopify": "https://cdn.shopify.com/shopifycloud/brochure/assets/brand-assets/shopify-logo-primary-logo-456baa801ee66a0a435671082365958316831c9960c480451dd0330bcdae304f.svg",
      "Liquid": "https://shopify.github.io/liquid/img/liquid-logo.svg",
      "JavaScript": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      "Svelte": "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/svelte/svelte-original.svg",
      "SvelteKit": "https://kit.svelte.dev/logo.svg",
      "Supabase": "https://supabase.com/images/brand/logo.svg",
      "Material-UI": "https://mui.com/static/logo.svg",
      "HTML":"./image/html.jpeg",
      "CSS":"./image/css.jpeg",
      "Bootstrap":"./image/bootsrap.jpeg",
      "WordPress":"./image/wordpress.jpeg"
    };
    return logos[language] || "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg";
  };

  const projects = [
        {
      id: 9,
      title: "Nouaceur WingsTech",
      image: "./image/noucer.jpg",
      link: "https://nouaceur-front.vercel.app/",
      languages: ["React","Tailwind CSS"]
    },
        {
      id: 2,
      title: "The Social Observatory",
      image: "./image/social.jpg",
      link: "https://www.the-social-observatory.com/",
      languages: [ "React", "Laravel","Tailwind CSS", "MySQL"]
    },
    {
      id: 2,
      title: "Salle de Sport",
      image: "./image/salle de sport.jpg",
      link: "https://salle-de-sports.vercel.app/",
      languages: ["HTML", "CSS", "JavaScript","Tailwind CSS"]
    },
    {
      id: 3,
      title: "Doctor",
      image: "./image/doctor.jpg",
      link: "https://doctor-omega-sandy.vercel.app/",
      languages: ["HTML", "CSS", "JavaScript","Tailwind CSS"]
    },
            {
      id: 9,
      title: "Portfolio Marketing Digital",
      image: "./image/abdo.jpg",
      link: "https://ajabbouneabdelilah.vercel.app/",
      languages: ["React","Tailwind CSS"]
    },
            {
      id: 9,
      title: "Site de Restaurant",
      image: "./image/briwhaat.jpg",
      link: "https://brihwaat.vercel.app/",
      languages: ["React","Tailwind CSS"]
    },
    {
      id: 18,
      title: "Laiding Page Radiologie",
      image: "./image/radio.jpg",
      link: "https://radiologie-al-quods.vercel.app/",
      languages: ["HTML", "CSS", "JavaScript","Tailwind CSS"]
    },

    {
      id: 18,
      title: "Laiding Page laboratoire ",
      image: "./image/labo.jpg",
      link: "https://laboratiore.vercel.app/",
      languages: ["HTML", "CSS", "JavaScript","Tailwind CSS"]
    },
            {
      id: 19,
      title: "Application de gestion de formation Noucer Wings Tech",
      image: "./image/wings.jpg",
      link: "https://github.com/MOSTAFA-AL-MANNANI/",
      languages: ["Laravel", "React", "MySQL"]
    },
        {
      id: 11,
      title: "Formation",
      image: "./image/formation.jpg",
      link: "https://projet-profesionnel.vercel.app/",
      languages: ["HTML", "CSS", "JavaScript","Bootstrap"]
    },

    {
      id: 5,
      title: "Agence de Vopyage",
      image: "./image/voyage.jpg",
      link: "agence-de-voyage-kappa.vercel.app",
      languages: ["HTML", "CSS", "JavaScript","Bootstrap"]
    },
    {
      id: 6,
      title: "Restaurant",
      image: "./image/restaurant.jpg",
      link: "project-restaurant-sigma.vercel.app",
      languages: ["HTML", "CSS", "JavaScript","Bootstrap"]
    },
    {
      id: 7,
      title: "Laiding Page Ecommerce",
      image: "./image/ecoomerce.jpg",
      link: "https://laiding-page-ecoshop.vercel.app/",
      languages: ["HTML", "CSS", "JavaScript","Bootstrap"]
    },
    {
      id: 10,
      title: "Laiding Page",
      image: "./image/laiding.jpg",
      link: "https://html-scss-ecommerce.vercel.app/",
      languages: ["HTML", "CSS", "JavaScript"]
    },
        {
      id: 4,
      title: "Location de Voiture",
      image: "./image/location.jpeg",
      link: "https://github.com/MOSTAFA-AL-MANNANI/",
      languages: ["React", "Laravel", "MySQL"]
    },
    {
      id: 12,
      title: "Ain Elhadath",
      image: "./image/A5.jpg",
      link: "https://ainelhadath.ma/",
      languages: ["WordPress"]
    },
        {
      id: 8,
      title: "Application Agence de Voyage",
      image: "./image/pfe1.jpg",
      link: "https://github.com/MOSTAFA-AL-MANNANI/",
      languages: ["Laravel", "React", "MySQL"]
    },
        {
      id: 1,
      title: "E-commerce Platform",
      image: "./image/eco.jpg",
      link: "https://github.com/MOSTAFA-AL-MANNANI/",
      languages: ["Laravel","MySQL"]
    },
    {
      id: 13,
      title: "Site E-commerce",
      image: "./image/ecoshop.jpg",
      link: "https://github.com/MOSTAFA-AL-MANNANI/",
      languages: [ "Laravel", "MySQL"]
    },
    {
      id: 14,
      title: "Dahmis",
      image: "./image/dahmis.jpg",
      link: "https://github.com/MOSTAFA-AL-MANNANI/",
      languages: ["Laravel", "MySQL"]
    },
    {
      id: 15,
      title: "Site Pharmacie",
      image: "./image/pha.jpg",
      link: "https://github.com/MOSTAFA-AL-MANNANI/",
      languages: ["React", "Laravel", "MySQL"]
    },
    
  ];

  const handleShowMore = () => {
    const newVisibleCount = visibleProjects + 3;
    if (newVisibleCount >= projects.length) {
      setVisibleProjects(projects.length);
      setShowEndMessage(true);
    } else {
      setVisibleProjects(newVisibleCount);
    }
  };

  const handleReset = () => {
    setVisibleProjects(6);
    setShowEndMessage(false);
  };

  return (
    <section id="projects" className="py-20 relative overflow-hidden">
      {/* Background gradient same as Hero */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-slate-900 to-purple-900"></div>
      
      {/* Enhanced animated background elements - same as Hero */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-slate-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/4 w-60 h-60 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-10 animate-pulse delay-500"></div>
        <div className="absolute top-1/3 right-1/3 w-40 h-40 bg-yellow-500 rounded-full mix-blend-multiply filter blur-xl opacity-15 animate-pulse delay-1500"></div>
      </div>

      {/* Floating particles effect - same as Hero */}
      <div className="absolute inset-0">
        {React.useMemo(() => 
          [...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-white rounded-full opacity-30 animate-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 2}s`
              }}
            ></div>
          )), [])}
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Mes Projets
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-slate-400 to-purple-400 mx-auto rounded-full"></div>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {projects.slice(0, visibleProjects).map((project, index) => (
            <div 
              key={project.id} 
              className="group animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative w-[330px] h-[230px] mx-auto overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:scale-110 hover:rotate-1">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-slate-400/70 opacity-0 group-hover:opacity-100 transition-all duration-500 flex flex-col items-center justify-center backdrop-blur-sm">
                  {/* Project title on hover */}
                  <h3 className="text-white font-light text-lg mb-4 text-center px-4 leading-tight">{project.title}</h3>
                  
                  {/* Languages logos */}
                  <div className="flex items-center justify-center space-x-3 mb-6">
                    {project.languages.map((language, langIndex) => (
                      <div key={langIndex} className="flex flex-col items-center">
                        <img 
                          src={getLanguageLogo(language)} 
                          alt={language}
                          className="w-8 h-8 rounded-lg bg-white/20 p-1 hover:scale-110 transition-transform duration-200"
                          title={language}
                        />
                        <span className="text-xs text-white mt-1 font-light">{language}</span>
                      </div>
                    ))}
                  </div>
                  
                  {/* Link button with icon */}
                  <a 
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-4 bg-white/90 text-slate-600 rounded-full hover:bg-white transition-all duration-300 transform hover:scale-110 hover:rotate-12 shadow-xl"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Show More Button */}
        <div className="text-center animate-fade-in">
          {!showEndMessage && visibleProjects < projects.length ? (
            <button
              onClick={handleShowMore}
              className="px-8 py-3 border-2 border-white bg-gradient-to-r from-slate-500 to-purple-600 text-white font-semibold rounded-lg hover:from-slate-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl animate-pulse"
            >
              Afficher plus
            </button>
          ) : (
            <button
              onClick={handleReset}
              className="px-8 py-3 border-2 border-white bg-gradient-to-r from-green-500 to-emerald-600 text-white font-semibold rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl animate-bounce"
            >
              Fin de travail
            </button>
          )}
        </div>
      </div>

      {/* Custom animations - same as Hero */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </section>
  );
};

export default Projects; 